import apiClient from "./client";

export async function fetchRestructurings({ status = "all", search } = {}) {
  const { data } = await apiClient.get("/repayments/restructurings", {
    params: { status, search: search || undefined },
  });
  return data;
}

export async function fetchRestructuring(restructuringId) {
  const { data } = await apiClient.get(`/repayments/restructurings/${restructuringId}`);
  return data;
}

export async function fetchRestructuringPreview(loanId, params) {
  const { data } = await apiClient.get(`/repayments/loans/${loanId}/restructuring/preview`, {
    params,
  });
  return data;
}

export async function createRestructuring(payload) {
  const { data } = await apiClient.post("/repayments/restructurings", payload);
  return data;
}

export async function updateRestructuring(restructuringId, payload) {
  const { data } = await apiClient.patch(`/repayments/restructurings/${restructuringId}`, payload);
  return data;
}

export async function cancelRestructuring(restructuringId) {
  const { data } = await apiClient.delete(`/repayments/restructurings/${restructuringId}`);
  return data;
}

export async function approveRestructuring(restructuringId) {
  const { data } = await apiClient.post(`/repayments/restructurings/${restructuringId}/approve`);
  return data;
}

export async function rejectRestructuring(restructuringId, reason) {
  const { data } = await apiClient.post(`/repayments/restructurings/${restructuringId}/reject`, {
    reason,
  });
  return data;
}
